import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-robot-dashboard',
  templateUrl: './price-robot-dashboard.component.html',
  styleUrls: ['./price-robot-dashboard.component.scss']
})
export class PriceRobotDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
